export const nullFunc = () => {
    return null;
};
